import { render, staticRenderFns } from "./InputWysiwyg.vue?vue&type=template&id=fbccc06a&scoped=true&"
import script from "./InputWysiwyg.vue?vue&type=script&lang=js&"
export * from "./InputWysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./InputWysiwyg.vue?vue&type=style&index=0&id=fbccc06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbccc06a",
  null
  
)

export default component.exports